export function Loader() {
  return (
    <div class='spinner-border text-success app-spinner' role='status'>
      <span class='sr-only'></span>
    </div>
  );
}
